




















import Vue from 'vue'
import SimpleModalLayout from '@/components/modal/basics/SimpleModal/SimpleModalLayout.vue'
import SimpleModalFooterButton from '@/components/modal/basics//SimpleModal/SimpleModalFooterButton.vue'

export default Vue.extend({
  components: {
    SimpleModalLayout,
    SimpleModalFooterButton,
  },
  props: {
    name: {
      type: String as () => string,
      default: '',
    },
    header: {
      type: String as () => string,
      default: '',
    },
    body: {
      type: String as () => string,
      default: '',
    },
  },
  methods: {
    handleOk() {
      this.$modal.pop()
      this.$emit('ok')
    },
  },
})
